import React, {FC} from "react"

import authentication from "@irati/auth"
import {CompanyNewsTile} from "@irati/types"
import {getInternalLinkFromString} from "@irati/utils/links"
import {cultureHubTracking} from "@irati-tracking/homepage"

import {useCustomerFile} from "@irati/customer-files/hooks/customerFile"
import {StyledLink} from "./styled"

interface Props {
  children: JSX.Element
  companyNewsTile: CompanyNewsTile
  tilesCount: number
}

const LinkWrapper: FC<Props> = ({children, companyNewsTile, tilesCount}) => {
  const {url} = companyNewsTile.config
  const {data} = useCustomerFile({uuid: companyNewsTile.config?.fileId}, {skip: !companyNewsTile.config?.fileId})

  if (data?.downloadUrl) {
    const handleOpenPdf = () => {
      const viewerUrl = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(data?.downloadUrl)}&disableDownload=true&toolbar=0`
      window.open(viewerUrl, "_blank")
    }

    return <StyledLink onClick={handleOpenPdf}>{children}</StyledLink>
  }

  if (url) {
    const internalUrl = getInternalLinkFromString(url, authentication.userTenant().subdomain)
    if (internalUrl) {
      return <StyledLink href={internalUrl}>{children}</StyledLink>
    }

    return (
      <StyledLink
        onClick={() => cultureHubTracking.cultureHubTileClick(url, tilesCount)}
        href={url}
        target="_blank"
        rel="noopener noreferrer">
        {children}
      </StyledLink>
    )
  }

  return children
}

export default LinkWrapper
